import React from "react";

import { BaseDataResponseBody } from "../../types";
import Help from "./help";
import Notifications from "./notifications";
import { StyledBusinessUserSettings, BusinessUserContainer, IconSpacer } from "./styled";
import * as Types from "./types";
import User from "./user";

const BusinessUserSettings: React.FC<Types.BusinessUserSettings> = ({
  hasLiveChatFeature,
  businessUser,
  notifications = [],
  toggleOverlayVisibility,
  useSimplifiedLayout,
  businessUnit = {} as BaseDataResponseBody["businessUnit"],
  accountManager,
  hasAppError,
  canViewBillingIngformation,
}) => {
  const [toggleState, toggle] = React.useState<string>("");
  const toggleWithOverlay = React.useCallback(
    (state) => {
      toggleOverlayVisibility(state !== toggleState);
      toggle(state !== toggleState ? state : null);
    },
    [toggleState],
  );

  return (
    <StyledBusinessUserSettings id="business-user-settings">
      <BusinessUserContainer>
        {!useSimplifiedLayout && (
          <IconSpacer>
            <Help
              toggled={toggleState === "help"}
              toggle={() => toggleWithOverlay("help")}
              hasLiveChatFeature={hasLiveChatFeature}
              accountmanager={accountManager}
              businessUserCountry={businessUser.country.country}
              businessUnitCountry={businessUnit.country}
              addressCountryCode={businessUnit.addressCountryCode}
            />
            <Notifications
              toggled={toggleState === "notifications"}
              toggle={() => toggleWithOverlay("notifications")}
              items={notifications}
              businessUserId={businessUser.id}
              businessUserEmail={businessUser.email}
              businessUnit={businessUnit}
            />
          </IconSpacer>
        )}

        <User
          toggled={toggleState === "userSettings"}
          toggle={() => toggleWithOverlay("userSettings")}
          businessUser={businessUser}
          useSimplifiedLayout={useSimplifiedLayout}
          hasAppError={hasAppError}
          canViewBillingIngformation={canViewBillingIngformation}
        />
      </BusinessUserContainer>
    </StyledBusinessUserSettings>
  );
};

export default BusinessUserSettings;
